import { render, staticRenderFns } from "./shenPurchasedDetail.vue?vue&type=template&id=cee88a32&"
import script from "./shenPurchasedDetail.vue?vue&type=script&lang=js&"
export * from "./shenPurchasedDetail.vue?vue&type=script&lang=js&"
import style0 from "./shenPurchasedDetail.vue?vue&type=style&index=0&id=cee88a32&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports